import { Environment } from 'config';
import request from 'utils/request';
import * as Types from '../types';
import { varToStringParams } from 'utils/path';
import _ from 'lodash';
import FileType from 'constants/fileType';
import FileContentType from 'constants/fileContentType';

/** fetchPointofInterestList  */
export interface IPointofInterestListOutput {
  items: IDataItems[];
  paging: IPaging;
}

export interface IDataItems {
  id: number;
  guid: string | null;
  name: string | null;
  description: string | null;
  location: any;
  category: number[];
  private: boolean;
  colour: string | null;
  published: boolean;
  storeid: number;
  createdat: string | null;
  createdby: number;
  pictures?: IDocumentPayload[];
}

interface IPaging {
  page: number;
  pageSize: number;
  total: number;
}

export interface IPointofInterestListInput {
  name?: string;
  tlc_lat?: number | null;
  tlc_lng?: number | null;
  trc_lat?: number | null;
  trc_lng?: number | null;
  blc_lat?: number | null;
  blc_lng?: number | null;
  brc_lat?: number | null;
  brc_lng?: number | null;
  sortField?: string;
  page?: number;
  pageSize?: number;
  order?: 'asc' | 'desc';
}

export const fetchPointofInterestList = async (
  payload: IPointofInterestListInput
): Promise<Types.ResponseOutput> => {
  const query = varToStringParams({
    variablesArray: [
      ...Object.keys(payload).map((key: string, index: number) => ({
        key: key,
        value: _.get(payload, key, undefined),
      })),
    ],
  });
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/pointofinterest/list${query}`
  );

  let _data: IPointofInterestListOutput = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

/** PointofInterest Detail */
interface IPointofInterestDetailInput {
  id: number;
}

interface IPointofInterestDetailOutput extends Types.ResponseOutput {
  data: {
    id: number | null;
    guid: string | null;
    name: string | null;
    description: string | null;
    location: string | null;
    category: number | null;
    private: number | null;
    colour: string | null;
    published: number | null;
    storeid: number | null;
    createdat: string | null;
    createdby: number | null;
  };
}

export const fetchPointofInterestDetail = async (
  payload: IPointofInterestDetailInput
): Promise<IPointofInterestDetailOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/pointofinterest/${payload.id}`
  );

  let output = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};

/** Add PointofInterest */
export interface IDocumentPayload {
  id?: number;
  mimetype: string;
  seofilename?: string;
  altattribute?: string;
  titleattribute?: string;
  virtualpath?: string;
  originalfilename?: string;
  filesize?: number;
  visible?: boolean;
  filetype: FileType;
  filecontenttype: FileContentType;
  displayorder?: number;
  payload?: string;
}
export interface IPointofInterestAddInput {
  id?: number;
  guid?: string;
  name: string | null;
  description: string | null;
  location: {
    lat: number;
    lng: number;
  } | null;
  category: number[] | null;
  private: boolean;
  colour: string | null;
  documents: Array<IDocumentPayload> | null;
}

interface IPointofInterestAddOutput extends Types.ResponseOutput {
  data: {};
}

export const addPointofInterest = async (
  payload: IPointofInterestAddInput
): Promise<IPointofInterestAddOutput> => {
  const { data }: any = await request(
    'post',
    `${Environment.API_BASE_URL}/api/pointofinterest`,
    { body: payload }
  );

  let output = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};

export const editPointofInterest = async (
  payload: IPointofInterestAddInput
): Promise<IPointofInterestAddOutput> => {
  const { id, ...rest } = payload;
  const { data }: any = await request(
    'patch',
    `${Environment.API_BASE_URL}/api/pointofinterest/${id}`,
    { body: rest }
  );

  let output = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};

export const deletePointofInterest = async (
  id: number
): Promise<IPointofInterestAddOutput> => {
  const { data }: any = await request(
    'delete',
    `${Environment.API_BASE_URL}/api/pointofinterest/${id}`
  );

  let output = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};
